import { Button } from '@/components/button';
import { Modal, ModalBody, ModalButtonContainer } from '@/components/modal/modal';
import modalStyles from '@/components/modal/modal.module.css';
import { useTranslation } from '@/contexts/i18n-context';

interface ReviewExitModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinueEditing: () => void;
  onResubmit: () => void;
  isResubmitting?: boolean;
}

export function ReviewExitModal({
  isOpen,
  onClose,
  onContinueEditing,
  onResubmit,
  isResubmitting,
}: ReviewExitModalProps) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOutsideClick>
      <h2 className="h4">{t('visit.review.exitModal.title')}</h2>
      <ModalBody>
        <p className="body-1">{t('visit.review.exitModal.description')}</p>
      </ModalBody>
      <ModalButtonContainer>
        <Button
          className={modalStyles.cancelButton}
          onClick={onContinueEditing}
          disabled={isResubmitting}
        >
          {t('visit.review.exitModal.continueEditing')}
        </Button>
        <Button className={modalStyles.confirmButton} onClick={onResubmit} loading={isResubmitting}>
          {t('visit.review.exitModal.resubmitVisit')}
        </Button>
      </ModalButtonContainer>
    </Modal>
  );
}
